<template>
  <div class="my_form">
    <el-dialog title="加班明细" :visible.sync="visible" width="1000px" top='20vh' :before-close="onClose">
      <PTable :columns="columns" :loadData="loadData" ref="table" :showSize="false"/>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PTable from '@/components/PTable';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PTable
  },
  watch: {
    record: {
      handler(val) {
        console.log(val);
        if(this.$refs.table) this.$refs.table.refresh(true)
      },
      immediate: true,
      deep:true
    }
  },
  data() {
    return {
      columns: [
        {
          label: '基本信息',
          children: [
            {
              label: '序号',
              prop: 'index',
              width: 100,
              fixed: "left"
            },
            {
              label: '姓名',
              prop: 'name',
              // width: 100
            },
            {
              label: '部门',
              prop: 'deptName',
              // width: 100
            }
          ]
        },
        {
          label: '加班时间',
          children: [{
            label: '加班开始时间',
            prop: 'startTime',
            // width: 100
          },
          {
            label: '加班结束时间',
            prop: 'realOffTime',
            // width: 100
          },
          {
            label: '加班时长',
            prop: 'workTimes',
            // width: 100
          }
          ]
        }
      ],
      loadData: (pageParam) => {
        return new Promise((resolve, reject) => {
            resolve({
              data: {
                totalCount: this.record.length,
                dataList: this.record
              }
            })
        })
      }
    };
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
    },
    onDialogClose() {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>
